<template>
	<div class="my_excelup" v-loading="fullloading" element-loading-text="拼命加载中......"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- <button @click="refresh_postjosn">{{ pre_title }}</button> -->
		<div class="pre_more">
			<span class="pre_excel_down_bg" @click="closeshow"></span>
			<div class="pre_excel_down_conten">
				<span class="pre_more_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">
					<div class="pre_leve_one">
						<button class="pre_btn_ok" @click="downloaddata">导出</button>
						<button class="pre_btn_ok" @click="cancel_downloaddata">
							取消
						</button>
					</div>
					<div class="pre_leve_two">
						<!-- table部分 -->
						<div class="pre_tab">
							<table id="pre_dataintable" class="pre_dataintable">
								<thead>
									<slot name="tab_excelup_title"></slot>
								</thead>
								<tbody>
									<slot name="tab_excelup_tr" v-for="data_tr in show_Data" :item="data_tr"></slot>
								</tbody>
							</table>
						</div>
					</div>
					<a id="downlink"></a>
					<a id="loodlink" target="_blank"></a>

					<!-- 弹出向导层 end-->
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	/*
名称：导出Excel
日期：2019-06-21
作者：hj
目标：
1、根据输入参数查询指定数据
2、将查询到的数据展示到界面，
3、执行导出，下载到本地桌面
*/
	import t from '@/utils/type.js'
	import {
		GetShort,
		BackSpecial,
		DeleteSpecialWord
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';
	import table2excel from '@/utils/jquery.table2excel.js';

	export default {
		name: "pre_excel_down",
		data() {
			return {
				fullloading: false,
				show_exceldata: false,
				imFile: "", // 导入文件el
				xlsxJson: '',
				errorDialog: false, // 错误信息弹窗
				errorMsg: "", // 错误信息内容
				excelData: [], // 总的Excel信息
				show_Data: [], // 展示Excel信息

				show_page: false,
				maxpage: '',
				nowpage: '',
				jumppage: '',
				perpage: 15,
				all_count: 0,
				page_length: 0,

				pre_url: '',
				pre_post: '',
				post_json: {},
				pre_title: '',
				pre_type: '',

				errnum: ''
			};
		},
		props: {
			title: {
				type: String,
				default: ''
			},
			clicktype: {
				type: String,
				default: ''
			},
			pre_postjson: {
				type: Object,
				default: function() {}
			}
		},
		created: function() {
			this.nowpage = 1;
			// this.build_data();
		},
		watch: {
			pre_postjson(val, old) {
				this.post_json = {};
				this.post_json = val;
				this.check_post_josn();

			}
		},
		mounted() {
			this.imFile = document.getElementById("imFile");
			// this.build_data(); //这里也不行
			this.$nextTick(function() {

				// this.post_json=this.$parent.postjson;
				setTimeout(this.build_data(), 2000);
			})
		},
		methods: {
			build_data: function() {
				this.pre_title = this.title;
				this.pre_type = this.clicktype;

			},
			check_post_josn: function() {

				this.pre_url = this.post_json.url;
				this.pre_post = this.post_json.post;
				this.loaddata();
			},
			openshow: function() {
				var Hg = $(document).height();
				// 设置背景高度
				$(".pre_excel_down_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pre_excel_down_bg").fadeIn("3000");
				$(".pre_excel_down_conten").fadeIn("3000");
			},
			closeshow: function() {
				$(".pre_excel_down_bg").fadeOut("3000");
				$(".pre_excel_down_conten").fadeOut("3000");
				this.$emit('exceldown-event', 'close');
			},
			loaddata: function() {
				// 执行下载
				this.fullloading = true;
				this.excelData = [];
				this.$post(
					this.pre_url,
					this.pre_post,
				).then(res => {
					this.fullloading = false;
					try {
						res = JSON.parse(res);
						console.log(res);
						let res_page = [];
						res_page = res[0][0];

						if (res_page.flag == 1) {

							this.nowpage = res_page.page_now;
							this.page_length = res_page.page_length;
							this.maxpage = res_page.all_page;
							this.all_count = res_page.all_count;

							if (this.all_count > 0) {

								let t = res[1];
								for (let i = 0; i < t.length; i++) {
									let arr = [];
									let temp_no = {};
									temp_no.key = 'row_num';
									temp_no.val = (this.nowpage - 1) * this.page_length + i + 1;
									// console.log('序号=' + temp_no.val);

									for (let j in t[i]) {
										// console.log('key=' + j);       //输出key
										// console.log('val=' + t[i][j]); //输出key对应的value
										let o = {};
										o.key = j;
										o.val = t[i][j];
										arr.push(o);
									}

									arr.splice(1, 0, temp_no);

									this.excelData.push(arr);
									this.checkdata();
								}

							}
						} else {

							this.$message({
								message: res.data.msg,
								type: 'warning'
							});

							this.maxpage = 0;
							this.excelData = [];
						}
						// this.loadjson1=''
					} catch (ex) {
						this.$message({
							message: ex,
							type: 'warning'
						});
					}
				});
			},
			checkdata: function() {
				// 执行格式转换



				this.showdata();
			},
			showdata: function() {
				// 执行展示

				// if(this.excelData.length>this.perpage){
				//   this.show_page=true;
				// }else{
				//   this.show_page=false;
				// }
				// this.show_Data=[];
				// var j=0
				// for(var i=0;i<this.excelData.length;i++){
				//   if(i>=((this.nowpage-1)*this.perpage)&&i<(this.nowpage*this.perpage-1)){
				//     this.show_Data[j]=this.excelData[i];
				//     j++;
				//   }
				// }
				this.show_Data = this.excelData;
				this.openshow();
			},
			downloaddata: function() {
				// table2excel
				var myDate = new Date();
				// console.log(this.formatDate(myDate,'yyyy_MM_dd hh_mm_ss'));
				myDate = this.formatDate(myDate, 'yyyy_MM_dd_hh_mm_ss');
				$("#pre_dataintable").table2excel({
					exclude: ".noExl",
					name: "table2excel", //文件名称,
					filename: 'down_' + myDate + '.xls',
					exclude_img: false,
					exclude_links: false,
					exclude_inputs: true
				});
			},
			cancel_downloaddata: function() {
				this.excelData = [];
				this.pre_step = [];
				this.pre_role = [];
				this.post_data = '';
				this.closeshow();
			},
			formatDate(date, fmt = this.format) {
				// 长度为10的时候末尾补3个0
				if (date === null || date === "null") {
					return "--";
				}
				date = new Date(Number(date));
				var o = {
					"M+": date.getMonth() + 1, // 月份
					"d+": date.getDate(), // 日
					"h+": date.getHours(), // 小时
					"m+": date.getMinutes(), // 分
					"s+": date.getSeconds(), // 秒
					"q+": Math.floor((date.getMonth() + 3) / 3), // 季度
					S: date.getMilliseconds() // 毫秒
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(
						RegExp.$1,
						(date.getFullYear() + "").substr(4 - RegExp.$1.length)
					);
				for (var k in o) {
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(
							RegExp.$1,
							RegExp.$1.length === 1 ?
							o[k] :
							("00" + o[k]).substr(("" + o[k]).length)
						);
				}
				return fmt;
			}
		}
	};
</script>


<style scoped>
	.my_excelup {
		display: inline-block;
		margin-left: 10px;
	}

	.pre_excel_down_bg {
		width: 100%;
		background: #000000;
		opacity: 0.5;
		position: fixed;
		top: 0;
		left: 0;
		height: 1340px;
		display: none;
		z-index: 99;
	}

	.pre_more {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	.pre_excel_down_conten {
		width: 70%;
		height: auto;
		margin: 0 auto;
		background: #faf5f5;
		position: fixed;
		top: 20%;
		border-radius: 3px;
		display: none;
		z-index: 999;
		/* left: 40%; */
		left: 15%;
		/* text-align: center; */
	}

	.pre_more_close {
		position: absolute !important;
		right: -8px !important;
		top: -6px !important;
		font-size: 30px !important;
		color: #b4b4b4;
		cursor: pointer;
		font-weight: normal;
	}

	.pre_excel_down_conten>div {
		/* margin-top: 15px; */
		width: 100%;
		text-align: center;
		padding-left: 5px;
		padding-right: 5px;
	}

	.pre_excel_down_conten>div>* {
		/* display: inline-block; */
		border-radius: 5px;
		/* line-height: 15px; */
	}

	.pre_excel_down_conten>div>span {
		width: 100px;
		/* margin-left: -40px; */
		text-align: right;
	}

	.pre_excel_down_conten>div>input {
		width: 168px;
		margin-right: 32px;
	}

	.pre_excel_down_conten>div>button {
		/* margin-left: 20%; */
		background-color: rgba(68, 70, 238, 0.986);
		color: white;
		font-optical-sizing: 16px;
		cursor: pointer;
	}

	.pre_upload {
		width: 100%;
		min-height: 200px;
		height: 100%;
		background-color: #f9f9f9;
		text-align: center;
		/* padding: 10px 20px 10px 20px; */
	}

	.pre_leve_one {
		height: 25px;
		text-align: left;
		padding-top: 18px;
		padding-left: 15px;
	}

	.pre_leve_one>button {
		margin-left: 10px;
		border-radius: 2px;
		background-color: #fff;
		color: #000000;
		padding: 2px 10px 2px 10px;
	}

	.pre_leve_two {
		/* padding: 5px; */
		margin: 15px;
		margin-top: 15px;
		border: 1px solid #191970;
		min-height: 200px;
		height: calc(100vh-400px);
	}

	.pre_tab {
		width: calc(100% - 5px);
		overflow-x: auto;
		white-space: nowrap;
	}

	.pre_dataintable {
		margin-top: 3px;
		table-layout: fixed;
		border-collapse: collapse;
		border-spacing: 0;
	}

	.pre_dataintable thead {
		display: table-row;
	}

	.pre_dataintable tbody {
		overflow-y: scroll;
		overflow-x: hidden;
		display: block;
		height: calc(100vh - 300px);
	}

	.pre_dataintable th,
	.pre_dataintable td {
		padding-top: 1px;
		padding-bottom: 1px;
		padding-left: 5px;
		padding-right: 5px;
		vertical-align: middle;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: hidden;
		min-width: 120px;
		width: 1px;
		max-width: 120px;
		text-overflow: ellipsis;
		border: 1px solid #3f3f3f;
	}

	.pre_dataintable th {
		background-color: rgb(87, 201, 230);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
	}

	.pre_dataintable td {
		/* vertical-align: center; */
		text-align: left;
		border: 1px solid #aaa;
	}

	.pre_dataintable tr th:nth-child(1),
	.pre_dataintable tr td:nth-child(1) {
		display: none;
		min-width: 48px;
		width: 48px;
	}

	.pre_dataintable tr th:nth-child(2),
	.pre_dataintable tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
	}

	.pre_dataintable tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_dataintable tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_tab_name {
		cursor: pointer;
		width: 100px;
		text-align: left;
		/* white-space: nowrap; */
		word-break: break-all;
		overflow: hidden;
		/* text-overflow: ellipsis; */
		/* display: -webkit-box; */
		/* -webkit-line-clamp: auto; */
		/* -webkit-box-orient: vertical; */
	}

	.pre_tab_name:hover {
		cursor: pointer;
		background-color: #aaa;
	}

	.td_btn {
		text-align: center !important;
	}

	.td_btn>button {
		border-radius: 3px;
		width: 100px;
		height: 28px;
		padding: 1px 2px 2px 2px;
	}

	.td_btn>button:hover {
		background-color: rgba(155, 222, 231, 0.986);
		cursor: pointer;
	}

	/* 翻页样式 */
	.pre_block {
		width: 100%;
		margin-top: 5px;
		margin-bottom: 5px;
	}

	.pre_block>ul {
		text-align: right;
		list-style: none;
	}

	.pre_block>ul>li>a {
		text-decoration: none;
	}

	.pre_block>ul>li>.go {
		display: inline-block;
		width: 40px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_block>ul>li>a:hover {
		color: #394656;
	}

	.pre_btn_ok {
		background: rgba(68, 70, 238, 0.986);
		color: white;
		font-optical-sizing: 16px;
		cursor: pointer;
	}

	.pre_btn_ok:hover {
		background: rgba(161, 161, 192, 0.986);
	}
</style>